import { render, staticRenderFns } from "./request-payment-system.vue?vue&type=template&id=2ca27474&scoped=true"
import script from "./request-payment-system.vue?vue&type=script&lang=js"
export * from "./request-payment-system.vue?vue&type=script&lang=js"
import style0 from "./request-payment-system.vue?vue&type=style&index=0&id=2ca27474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca27474",
  null
  
)

export default component.exports